import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ConnectivityModulatingIcon = ({ color, ...rest }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorPrimary;

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5 15.9715C5 13.3255 5.93425 10.8977 7.49088 9L17 11.4V15.9715V20.6L7.49088 22.943C5.93425 21.0453 5 18.6175 5 15.9715Z"
        fill={currentColor}
      />
      <path
        d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
        stroke={currentColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M27.5 19L7.5 24" stroke={currentColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M27.5 13L7.5 8" stroke={currentColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ConnectivityModulatingIcon;
